import styled from "styled-components";

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  :last-child {
    margin-bottom: 16px;
  }
`;

export const CategoryName = styled.div`
  line-height: 24px;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 8px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const FlexWrapper = styled.div<{ gap?: number }>`
  display: flex;
  gap: ${({ gap = 8 }) => `${gap}px`};
  align-items: center;
  .pipe {
    color: var(--section-periwinkle-grey-color, var(--periwinkle-grey));
  }
`;
